import React from 'react'
import { Breadcrumb } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const routes = [
  {
    name: 'Home',
    route: '/',
  },
  {
    name: 'Peta Penyebaran',
    route: '/region-map'
  }
]

const Card = ({data}) => {
  const {
    name,
    image,
  } = data

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const size = isMobile ? '68px' : '150px'
  const backgroundSize = '50%'

  return (
    <div>
      <div
        className="rounded flex items-center -mx-2 lg:-mx-4 mb-8 lg:mb-0"
        // style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
      >
        {/* Image */}
        <div className="w-1/4 lg:w-2/12 px-2 lg:px-4">
          <div
            className="lg:w-full h-full bg-center bg-auto bg-no-repeat rounded rounded-full lg:mr-5"
            style={{
              width: size, height: size,
              backgroundColor: '#f9f9f9',
              backgroundImage: `url('${image}')`,
              backgroundBlendMode: 'multiply',
              backgroundSize: backgroundSize
            }}
          />
        </div>

        <div className="w-3/4 lg:w-10/12 px-2 lg:px-4">
          {/* Content */}
          <div className="w-full">
            <Breadcrumb routes={routes} color="#fff" className="lg:mb-1"/>
            <h3 className="font-bold text-xl md:text-5xl font-primary mb-2 leading-tight text-white uppercase font-accent">
              {name}
            </h3>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Card }